export interface ForeignExchanges {
    id?: number;
    name: string;
    currency_id: number | null;
    currency?: number | null;
    value: number;
    exchange_date?: string;
}

export interface ForeignExchangeFilters {
    id?: number | null;
    name?: string | '';
    currency?: number | null;
    value?: number | null;
    exchange_date_until?: string | null;
    exchange_date_from?: string | null;
    exchange_date?: string | null;
    page: number;
    per_page: number;
    sort: string;
    order: string;
}

export const defaultForeignExchangeDataForm: ForeignExchanges = {
    name: '',
    currency_id: null,
    value: 0
};